import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteContentContext = createContext();

export const useSiteContent = () => {
    const context = useContext(SiteContentContext);
    if (!context) {
        throw new Error('useSiteContent must be used within a SiteContentProvider');
    }
    return context;
};

export const SiteContentProvider = ({ children }) => {
    const [contents, setContents] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // İçerikleri yükle
    const fetchContents = async () => {
        try {
            // Relative /api kullanıyoruz; production'da same-origin, lokalde proxy/CORS ile çalışır
            const response = await axios.get('/api/site-contents');
            // Array'i key-value objesine çevir
            const contentMap = {};
            response.data.forEach(item => {
                contentMap[item.key] = item.value;
            });
            setContents(contentMap);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching site contents:', err);
            setError(err.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContents();
    }, []);

    // İçerik getir (key ile), yoksa fallback döndür
    const getContent = (key, fallback) => {
        return contents[key] || fallback;
    };

    // İçerikleri yeniden yükle (Admin panelinden güncelleme yapıldığında)
    const refreshContents = () => {
        return fetchContents();
    };

    return (
        <SiteContentContext.Provider value={{ contents, getContent, refreshContents, loading, error }}>
            {children}
        </SiteContentContext.Provider>
    );
};
